import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [
          _c("div", { staticClass: "text-body-2 text-secondary--text mb-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Пол врача", _setup.options)) +
                "\n    "
            ),
          ]),
        ]
      }),
      _vm._v(" "),
      _c(
        VChipGroup,
        {
          attrs: {
            value: _setup.doctorFiltersState.gender,
            column: "",
            "active-class": "primary",
          },
          on: { change: _setup.handleChangeChip },
        },
        _vm._l(_setup.genderChips, function (chip, i) {
          return _c(
            VChip,
            {
              key: i,
              attrs: {
                value: chip.value,
                color:
                  chip.value === _setup.doctorFiltersState.gender
                    ? "primary"
                    : "bg-primary",
                "text-color":
                  chip.value === _setup.doctorFiltersState.gender
                    ? "bg-gray-0"
                    : "primary",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t(chip.name, _setup.options)) +
                  "\n    "
              ),
            ]
          )
        }),
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }